module.exports = __webpack_public_path__ + "img/02_dife.1a27bb6b.jpg";